import { Component, ElementRef, output, ViewChild } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';


@Component({
  selector: 'app-file-uploader',
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './file-uploader.component.html',
  styleUrl: './file-uploader.component.scss'
})
export class FileUploaderComponent {
  @ViewChild('fileInput')
  fileInput: ElementRef<HTMLInputElement> | undefined;

  fileData = output<File[]>();

  // private fileStorage = inject(FilesStorageService);

  triggerFileInput(): void {
    this.fileInput?.nativeElement.click();
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input?.files || []);

    if (files.length) {
      this.uploadFiles(files);
    }
  }

  onFileDrop(event: DragEvent): void {
    event.preventDefault();
    const files = Array.from(event.dataTransfer?.files || []);
    if (files.length) {
      this.uploadFiles(files);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  uploadFiles(files: File[]): void {
    this.fileData.emit(files);
  }
}
